export default function wati(time=200){
	return new Promise(resolve => {
		setTimeout(resolve,time);
	})
}